/* Forms, view components */
import { RecipientForm } from '../forms//recipient-account';
import { TaxIDForm } from '../forms/recipient-verify';
import { ReviewForm } from '../forms/review';
import PropTypes from 'prop-types';
import EmailVerify from '../forms/email-verify';
import AddFirstAndLastName from '../forms/profile-name';
import AddProfilePhoto from '../forms/profile-pic';
import modal from '../modal/transactable-modal';
import { Helpers } from '../helpers/helpers';
import sharedAnalytics from './analytics';
import SvgInfo from '../icons/Info';
const Modal = modal.Modal;

import React from 'react';
import ReactDOM from 'react-dom';

import { Profile } from '../forms/profile';
import { Reviews } from '../forms/reviews';
import { FormattedMessage } from "react-intl";

/*Props -
- user
- intendedAction
- refreshAll
- hostFlag
*/

class Transactable extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      ready_to_transact: null,
      transition_button: null,
      form_being_served: "",
      form_to_serve: null,
      reviews: null,
      has_reviews: null,
      total_number_of_tasks: 0,
      missing: null,
      on_task: 0,
      override_close_behavior: false
    };

    this.findNextStateStatus = this.findNextStateStatus.bind(this)
    this.setForm = this.setForm.bind(this)
    this.moveAlong = this.moveAlong.bind(this)
    this.onUpdateReview = this.onUpdateReview.bind(this)
    this.onUpdateUser = this.onUpdateUser.bind(this)
    this.onUpdateRecipient = this.onUpdateRecipient.bind(this)
    this.onGetPendingReviews = this.onGetPendingReviews.bind(this)
    this.onUserTransactReturn = this.onUserTransactReturn.bind(this)
    this.onClickTransitionView = this.onClickTransitionView.bind(this)
    this.intendedAction = this.intendedAction.bind(this)
    this.transitionView = this.transitionView.bind(this)
    this.closeBehavior = this.closeBehavior.bind(this)
    this.handleSnoozeBtn = this.handleSnoozeBtn.bind(this);
  }

  static getUserStatus (SSOID, callback, hostFlag, domainPath) {
    const hostFlagString = hostFlag ? '?receive=true' : '';
    const path = domainPath ? `/${domainPath}` : '';
    const url = `/v1/profiles/${SSOID}/status/transact${path}${hostFlagString}`;
    const accessToken = PSSessions.Cookies('PSAccess');
    const sendOptions = {
      context: this,
      cache: false,
      type: 'GET',
      url: url,
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      }
    };
    $.ajax(sendOptions).done(function (res, textStatus, jqXHR) {
      return callback(res, textStatus, jqXHR);
    });
  }

  static updateUserInfo (profile, refreshAll) {
    ReactDOM.render(
      <Transactable user={profile} refreshAll={refreshAll}/>,
      document.getElementById('modal-container')
    )
  }

  findNextStateStatus (returningFrom, data, textStatus, userUpdated) {
    //this creates a newState hash that clears and moves certain values along
    const newState = {};
    const arrayOfTasks = this.state.missing;

    const formIndexInTask = arrayOfTasks.indexOf(returningFrom);
    //we pop it out of the array
    arrayOfTasks.splice(formIndexInTask, 1);

    newState.missing = arrayOfTasks;
    newState.form_to_serve = null;
    const updateUserFn = (userData) => {
      if (this.props.actions) {
        this.props.actions.updateProfile(userData);
      }
    };

    switch (returningFrom) {
    case 'Avatar':
      //update user prop, top level
      updateUserFn(data);
      break;
    case 'Email Verification':
      //update user prop, top level

      break;
    case 'First Name':
      //update user prop, top level
      updateUserFn(data);
      break;
    case 'Last Name':
      //update user prop, top level
      updateUserFn(data);
      break;
    case 'Pending Reviews to Complete':
      //update reviewsArray, pop out old review;
      //data arg is reviewID
      // find reviewObj by reviewID && pop out of array
      let updatedReviewsArr, currentReviewsArray = this.state.reviews;
      let finishedReviewID = data;
      if (finishedReviewID === this.state.reviews[0]._id) { /* which it always should*/
        currentReviewsArray.shift();
      }
      updatedReviewsArr = currentReviewsArray;
      newState.reviews = updatedReviewsArr.length > 0 ? updatedReviewsArr : null;

      break;
    case 'Recipient Missing':

      break;
    case 'Recipient not Verified':

      break;
    default:

      break;
    }
    return newState;
  }

  /*this is where the functions are to get the piece of the flow */
  setForm (whichForm, optionalNewStateHash, actualReviewObj) {
    const currentReviewNumber = optionalNewStateHash && optionalNewStateHash.hasOwnProperty('on_task') ? optionalNewStateHash.on_task : this.state.on_task + 1;
    const allForms = {
      'Avatar': <AddProfilePhoto user={this.props.user}  updateAction={Profile.updateProfileInfo}
                                 callback={this.onUpdateUser}/>,
      'Email Verification': <EmailVerify user={this.props.user}
                                         componentWillMountAction={Profile.sendEmailVerificationCode}
                                         updateAction={Profile.submitVerificationCode}
                                         callback={this.onUpdateUser}/>,
      'First Name': <AddFirstAndLastName user={this.props.user}
                                         updateAction={Profile.updateProfileInfo}
                                         callback={this.onUpdateUser} />,
      'Last Name': <AddFirstAndLastName user={this.props.user}
                                        updateAction={Profile.updateProfileInfo}
                                        callback={this.onUpdateUser} />,
      'Pending Reviews to Complete': <ReviewForm
        review={actualReviewObj}
        user={this.props.user}
        currentReview={currentReviewNumber}
        totalReviews={this.state.total_number_of_tasks}
        cbAction={this.onUpdateReview}
        snoozable={this.props.snoozeFeature || false}
        handleSnoozeBtn={this.handleSnoozeBtn}
      />,
      'Recipient Missing': <RecipientForm callback={this.onUpdateRecipient} />,
      'Recipient not Verified': <TaxIDForm callback={this.onUpdateRecipient} user={this.props.user} />
    };
    const formToServe = allForms[whichForm];
    if (optionalNewStateHash) {
      optionalNewStateHash.form_to_serve = formToServe;
      optionalNewStateHash.form_being_served = whichForm;
      this.setState(optionalNewStateHash);
    } else {
      this.setState({
        form_to_serve: formToServe,
        form_being_served: whichForm
      });
    }
  }
  moveAlong (returningFrom, data, textStatus, userUpdated, snoozed = false) {
    const nextState = this.findNextStateStatus(returningFrom, data, textStatus, userUpdated);
    let transitionButton;
    const userFriendlyActions = {
      'Avatar': "profile pic",
      'Email Verification': "email verification code",
      'First Name': "name",
      'Last Name': "name",
      'Pending Reviews to Complete': "review",
      'Recipient Missing': "bank account",
      'Recipient not Verified': "tax ID",
      'final check': "final check"
    };
    transitionButton = this.transitionView(snoozed ? 'snooze request' : userFriendlyActions[returningFrom]);
    nextState.transition_button = transitionButton;
    this.setState(nextState);
  }
  /* end */
  /* ajax calls & callbacks */
  onUpdateReview  (reviewID) {
    return this.moveAlong(this.state.form_being_served, reviewID);
  }

  onUpdateUser  (response, textStatus, jqXHR) {
    if ("success" === textStatus) {
      return this.moveAlong(this.state.form_being_served, response.profile, textStatus, true);
    }
  }

  onUpdateRecipient  () {
    this.moveAlong(this.state.form_being_served);
  }

  onGetPendingReviews  (data, textStatus, xhrObj) {
    if ("success" === textStatus) {
      const reviews = data;
      const numberOfReviews = reviews.length;
      //'Pending Reviews to Complete'
      //depending on number of reviews, update task Missing Array so it's our one source of truth
      const taskArray = this.state.missing || [];
      const numberOfReviewsNotificationsToAdd = taskArray.length > 0 ? numberOfReviews - 1 : numberOfReviews;
      for (let thisRev = 0; thisRev < numberOfReviewsNotificationsToAdd; thisRev++ ) {
        taskArray.push('Pending Reviews to Complete');
      }
      const newState = {
        on_task: 0,
        reviews: reviews,
        missing: taskArray,
        total_number_of_tasks: taskArray.length
      };
      return (this.setState(newState));
    }
  }

  onUserTransactReturn (data, textStatus, jqXHR) {
    const newState = {};
    if ("error" === textStatus) {
      // TODO: error handling
    } else if (data.ready_to_transact) {
      // updates state to override default closeBehavior
      // to make sure request booking button is not enabled intermittently
      // when user is transactable
      this.setState({override_close_behavior: true})

      this.setState({ ready_to_transact: data.ready_to_transact });
    } else {
      if (!data.ready_to_transact) {
        let hasReviews = false, firstNameIndex, lastNameIndex;
        newState.missing = data.missing;
        newState.ready_to_transact = data.ready_to_transact;
        if (analyticsIntegrations) { analyticsIntegrations.transactableViewed(data.missing) }

        for (let missing = 0; missing < data.missing.length; missing++) {
          //hardcoding this because I apparently can't get lodash to work
          if ("First Name" === data.missing[missing]) { firstNameIndex = missing; }
          if ("Last Name" === data.missing[missing]) { lastNameIndex = missing; }
          if ("Pending Reviews to Complete" === data.missing[missing]) { hasReviews = true; }
        }
        if (hasReviews) { newState.has_reviews = hasReviews; }
        //consolidate "first name" & "last name"
        if ((undefined !== firstNameIndex) && (undefined !== lastNameIndex)){ (newState.missing).splice(firstNameIndex, 1); }
        // add in collecting the recipient account if missing
        const recipIndex = newState.missing.indexOf('Recipient not Verified');
        if (-1 !== recipIndex && !this.props.user.data.recipient_id) {
          const ndxForBankCollection = recipIndex - 1;
          newState.missing.splice(ndxForBankCollection, 0, 'Recipient Missing');
        }

        const totalNumberOfTasks = newState.missing.length;
        newState.total_number_of_tasks = totalNumberOfTasks;
        this.setState(newState);
      }
    }
  }
  /* end ajax call */
  /* Start Lifecycle */
  componentWillMount () {
    const SSOID = this.props.user.SSOid;
    Transactable.getUserStatus(SSOID, this.onUserTransactReturn, this.props.hostFlag, this.props.domain);
  }

  componentWillReceiveProps (nextProps) {
    //when we update user state?
  }

  componentDidUpdate (prevProps, prevState) {
    if (!this.state.ready_to_transact && this.state.has_reviews && (null === this.state.reviews)) {
      // this means that we need to go get those reviews before moving forward
      return Reviews.getUserPendingReviewsWithSnooze(this.props.user.SSOid, this.onGetPendingReviews);
    }
    if (!this.state.ready_to_transact) {
      if (this.state.missing && 0 < this.state.missing.length) {
        if ((!this.state.transition_button && !this.state.form_to_serve)) {
          //because form_to_serve will set null upon return of successful form submission
          // read first missing task and apply it
          const nextFormName = this.state.missing[0];
          const onTaskNum = this.state.on_task + 1;
          const stateToUpdate = {};
          let review;
          stateToUpdate.on_task = onTaskNum;
          if ('Pending Reviews to Complete' === nextFormName) {
            review = this.state.reviews[0];
            const SSOid = this.props?.user?.SSOid;
            if (this.props.snoozeFeature && SSOid && review.host_id === SSOid) {
              const { booking_id } = review;
              sharedAnalytics.pendingReviewWithSnoozeViewed({ hostId: SSOid, bookingId: booking_id });
            }
          }
          return this.setForm(nextFormName, stateToUpdate, review);
        }
      }
    }
  }
  /* End Lifecycle */
  /* Click Handler */
  onClickTransitionView (event) {
    event.preventDefault();
    if (this.state.missing && 0 === this.state.missing.length) {
      Transactable.getUserStatus(this.props.user.SSOid, this.onUserTransactReturn, this.props.hostFlag, this.props.domain);
    } else {
      const newState = {};
      newState.transition_button = null;
      this.setState(newState);
    }
  }

  intendedAction (event) {
    const modalContainer = document.getElementById('modal-container');

    // unmount with React and kill modal
    ReactDOM.unmountComponentAtNode(modalContainer);
    $(modalContainer).data('bs.modal', null);

    return this.props.intendedAction();
  }
  /* Views */
  transitionView (actionType) {
    const { headerMargin } = this.props;
    const helperText = <FormattedMessage id="shared_components.transactable_main.transition_view_submitted" defaultMessage="Your {actionType} was successfully submitted!" values={{ actionType: actionType }}/>;
    const btnName = (this.state.missing && 0 < this.state.missing.length)
      ? <FormattedMessage id="shared_components.transactable_main.transition_view_next" defaultMessage="Next"/>
      : <FormattedMessage id="shared_components.transactable_main.transition_view_done" defaultMessage="Done"/>;
    return(
      <div className="col-xs-12 text-center">
        <h3 className={headerMargin || ''}>
          <FormattedMessage id='shared_components.transactable_main.thank_you' defaultMessage='Thank you' />
        </h3>
        <p>{helperText}</p>
        <button className="btn btn-primary btn-lg col-xs-4 col-xs-offset-4" onClick={this.onClickTransitionView}>{btnName}</button>
      </div>
    );
  }

  closeBehavior () {
    // Method for handling when user clicks out of modal
    // and doesn't continue with filling out info.

    const {override_close_behavior} = this.state

    if (this.props.closeBehavior && !override_close_behavior) {
      return this.props.closeBehavior();
    }

    return null;
  }

  handleSnoozeBtn(reviewId) {
    let ssoid, bookingId, count, deviceType;
    const { reviews = [] } = this.state;
    if (reviews.length > 0) {
      const currentReview = reviews[0];
      bookingId = currentReview.booking_id;
      ssoid = currentReview.host_id;
      count = currentReview.times_skipped + 1 || 1;
      deviceType = Helpers.isMobile() ? 'Mobile Web' : 'Web';
    }
    Reviews.snoozePendingReview(reviewId, ()=> {
      sharedAnalytics.snoozeButtonPressed(count, deviceType, ssoid, bookingId);
      this.moveAlong(this.state.form_being_served, reviewId, null, null, true);
    });
  }

  render () {
    const { snoozeFeature = false, hostFlag = false } = this.props;
    if (false === this.state.ready_to_transact) {
      let modalBody;
      if (this.state.form_to_serve) {
        modalBody = this.state.form_to_serve;
      } else if (this.state.transition_button) {
        modalBody = this.state.transition_button;
      } else {
        modalBody = '';
      }
      const currentReview = this.state.reviews && this.state.reviews.length > 0  ? this.state.reviews[0] : undefined;
      const ssoid = this.props?.user?.SSOid;
      const guestId = currentReview?.guest_id;
      const currentReviewAsGuest = ssoid && guestId ? ssoid === guestId : false;
      const currentReviewSnoozeLimit = currentReview && currentReview.hasOwnProperty('allowed_to_skip') && !currentReview.allowed_to_skip;
      const banner = {
        type: 'graybg margin-lg-bottom',
        text: <h4><FormattedMessage id='shared_components.transactable_main.banner_following' defaultMessage='Before you can move forward, please complete the following.' /></h4>
      };
      const zenDeskLocale = this.props.zenDeskUrlLocale || 'en-us';
      const snoozeBanner = {
        type: 'creambg',
        text: <div className='flex center middle'>
          <span className='info-banner'>
            <SvgInfo />
          </span>
          <p className="text-left">
            <FormattedMessage
              id='shared_components.transactable_main.banner_skip_limit_reached'
              defaultMessage='This review has reached its snooze limit. Please complete or {contact}.'
              values={{ contact: (<a href={`https://support.peerspace.com/hc/${zenDeskLocale}`} target="_blank" rel="noreferrer noopener">contact support for help</a>) }}
            />
          </p>
        </div>
      };
      let addCloseIcon; let showBanner; let whichBanner;
      if (!snoozeFeature) {
        addCloseIcon = true;
        showBanner = true;
        whichBanner = banner;
      } else {
        addCloseIcon = !hostFlag || currentReviewAsGuest || this.state.transition_button;
        if (this.state.transition_button || currentReviewAsGuest) {
          showBanner = true;
        } else {
          showBanner = currentReviewSnoozeLimit;
        }
        whichBanner = this.state.transition_button || currentReviewAsGuest ? banner : snoozeBanner;
      }
      return (
        <Modal
          addCloseIcon={addCloseIcon}
          modalID="transactable-modal"
          closeBehavior={this.closeBehavior}
          body={modalBody}
          show
          modalSize="lg-size"
          modalType="trans"
          showBanner={showBanner}
          banner={whichBanner}
        />
      );
    } else {
      return <Modal show={false} modalID="transactable-modal" closeBehavior={this.intendedAction}
                    modalSize="lg-size" modalType="trans" />;
    }
  }

}

Transactable.propTypes = {
  headerMargin: PropTypes.string,
  snoozable: PropTypes.bool,
  hostFlag: PropTypes.bool,
  snoozeFeature: PropTypes.bool
};

export default Transactable;
